// @flow

const breakpointsToArray = <D, SM, MD, LG, XL, T: { // eslint-disable-line arrow-parens
  default: D,
  sm?: SM,
  md?: MD,
  lg?: LG,
  xl?: XL,
}>(responseMap: T): [D, SM, MD, LG, XL] => {
  const d: D = responseMap.default;
  const sm: SM = responseMap.sm || ((d: any): SM);
  const md: MD = responseMap.md || ((sm: any): MD);
  const lg: LG = responseMap.lg || ((md: any): LG);
  const xl: XL = responseMap.xl || ((lg: any): XL);
  const breakpoints = [d, sm, md, lg, xl];

  return (breakpoints: [D, SM, MD, LG, XL]);
};

export default breakpointsToArray;
